export const CARD_HEIGHT = 36 * 6 + 8 + 8
